
import './menu-layout.css';

import angular from 'angular';

import menuLayout from './menu-layout';
import MenuLayoutController from './menu-layout.controller';
import Session from '../../service/session';
import User from '../../service/user';
import Sso from '../../service/sso';

export default angular.module('directive.menu-layout', [ User, Session, Sso ])
	.controller('MenuLayoutController', MenuLayoutController)
	.directive('menuLayout', menuLayout)
	.name;



// WEBPACK FOOTER //
// ./src/directive/menu-layout/index.js